import { useMutation } from '@apollo/client';
import { useAccount, useLogin } from '@bnnvara/accounts';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { PublicationViewedMutation } from '../../api/mutations/publicationViewed.gql';

/**
 * This component is responsible for sending that a publication is being viewed.
 * You can import this component on a page, and the view will be registered.
 * The mutation is being done both when you are logged in, as well as you are logged out.
 * When you are logged out, the UID is not provided.
 */
const PublicationViewed = ({ id, contentType }) => {
  const [publicationViewedMutation, { loading, called }] = useMutation(
    PublicationViewedMutation
  );
  const {
    profile: { UID },
  } = useAccount();
  const { status } = useLogin();
  const sendMutation = !loading && !called && status === 'idle';

  useEffect(() => {
    if (sendMutation) {
      publicationViewedMutation({
        variables: { contentId: id, contentType, userId: UID },
      });
    }
  }, [UID, publicationViewedMutation, id, sendMutation, contentType]);

  return null;
};

PublicationViewed.propTypes = {
  id: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
};

export default PublicationViewed;
